// src/pages/LoginPage.jsx
import React, { useEffect, useRef } from 'react';
import {
  FaBolt,
  FaShoppingCart,
  FaShieldAlt,
  FaShippingFast,
  FaArrowRight,
  FaUserCircle,
  FaStar,
  FaCheckCircle
} from 'react-icons/fa';
import LoginForm from '../components/Auth/LoginForm';
import '../styles/LoginPage.css';
import reanimeitorImage from '../Assets/reanimeitor-can.png.png';

const LoginPage = () => {
  const mobileStatsRef = useRef(null);

  useEffect(() => {
    document.body.classList.add('reanimeitor-login-view');

    document.title = 'Acceso a clientes | Reanimeitor Energy Drink';

    let metaDescription = document.querySelector('meta[name="description"]');

    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }

    metaDescription.setAttribute(
      'content',
      'Accede a tu cuenta de Reanimeitor Energy Drink para consultar tus pedidos, gestionar tus datos y revisar la información de tus compras.'
    );

    let canonical = document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute('href', 'https://reanimeitor.com/login');

    let robots = document.querySelector('meta[name="robots"]');

    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }

    robots.setAttribute('content', 'index, follow');

    return () => {
      document.body.classList.remove('reanimeitor-login-view');
    };
  }, []);

  useEffect(() => {
    const slider = mobileStatsRef.current;

    if (!slider) {
      return undefined;
    }

    let index = 0;

    const interval = setInterval(() => {
      if (window.innerWidth > 768) {
        return;
      }

      const slides = slider.querySelectorAll('.login-mobile-stat-slide');

      if (!slides.length) {
        return;
      }

      index = (index + 1) % slides.length;

      slider.scrollTo({
        left: slides[index].offsetLeft,
        behavior: 'smooth'
      });
    }, 3200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="login-futuristic-page">
      <div className="login-energy-background">
        <div className="login-particle-field"></div>
        <div className="login-grid-overlay"></div>
        <div className="login-ambient-glow login-ambient-glow-one"></div>
        <div className="login-ambient-glow login-ambient-glow-two"></div>
      </div>

      <div className="login-electric-layer">
        <span className="login-electric-line"></span>
        <span className="login-electric-line"></span>
        <span className="login-electric-line"></span>
        <span className="login-electric-line"></span>
        <span className="login-electric-node"></span>
        <span className="login-electric-node"></span>
        <span className="login-electric-node"></span>
        <span className="login-electric-node"></span>
      </div>

      <main className="login-futuristic-shell">
        <section className="login-product-zone">
          <div className="login-product-scene">
            <div className="login-scene-orbit login-scene-orbit-one"></div>
            <div className="login-scene-orbit login-scene-orbit-two"></div>
            <div className="login-can-light"></div>

            <div className="login-can-wrapper">
              <img
                src={reanimeitorImage}
                alt="Lata de Reanimeitor Energy Drink"
                className="login-can-image"
              />
            </div>

            <div className="login-floating-chip login-floating-chip-one">
              <FaBolt />
              <span>30mg cafeína / 100ml</span>
            </div>

            <div className="login-floating-chip login-floating-chip-two">
              <FaStar />
              <span>B6 · B12 · Taurina</span>
            </div>

            <div className="login-floating-chip login-floating-chip-three">
              <FaCheckCircle />
              <span>51 kcal / 100ml</span>
            </div>
          </div>

          <div className="login-product-copy">
            <div className="login-kicker">
              <span></span>
              REANIMEITOR ENERGY DRINK
            </div>

            <h1>
              Tu energía,
              <br />
              siempre a mano.
            </h1>

            <p>
              Accede a tu área de cliente para consultar pedidos, gestionar tus datos
              y continuar comprando tus packs de Reanimeitor.
            </p>

            <div className="login-mini-stats login-desktop-stats">
              <div>
                <strong>24-48h</strong>
                <small>envío estimado</small>
              </div>

              <div>
                <strong>Pack 24</strong>
                <small>formato destacado</small>
              </div>

              <div>
                <strong>Pack 48</strong>
                <small>mejor precio</small>
              </div>
            </div>

            <div className="login-mobile-stats-wrap">
              <div className="login-mobile-stats" ref={mobileStatsRef}>
                <div className="login-mobile-stat-slide">
                  <FaShippingFast />
                  <strong>24-48h</strong>
                  <small>envío estimado</small>
                </div>

                <div className="login-mobile-stat-slide">
                  <FaShoppingCart />
                  <strong>Pack 24</strong>
                  <small>formato destacado</small>
                </div>

                <div className="login-mobile-stat-slide">
                  <FaStar />
                  <strong>Pack 48</strong>
                  <small>mejor precio</small>
                </div>
              </div>

              <div className="login-mobile-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </section>

        <section className="login-access-zone">
          <div className="login-access-card">
            <div className="login-card-glow"></div>

            <div className="login-card-header">
              <div className="login-brand-mark">
                <FaBolt />
              </div>

              <div>
                <span className="login-brand-label">REANIMEITOR</span>
                <h2>Accede a tu cuenta</h2>
              </div>
            </div>

            <p className="login-card-subtitle">
              Entra para revisar tus compras, ver tus pedidos y gestionar tu perfil.
            </p>

            <div className="login-form-frame">
              <LoginForm />
            </div>

            <div className="login-action-hint">
              <FaArrowRight />
              <span>Después de iniciar sesión podrás finalizar tus compras.</span>
            </div>

            <div className="login-features-grid">
              <div className="login-feature-card">
                <FaShoppingCart />
                <span>Compras</span>
              </div>

              <div className="login-feature-card">
                <FaUserCircle />
                <span>Perfil</span>
              </div>

              <div className="login-feature-card">
                <FaShippingFast />
                <span>Pedidos</span>
              </div>

              <div className="login-feature-card">
                <FaShieldAlt />
                <span>Acceso seguro</span>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default LoginPage;